/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/muumimaa/"

const muumimaa: CommunityData = {
  code: "muumimaa",
  inviteCode: "muumimaa",
  name: "Muumimaa Collective",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/muc-045`,
  socials: {},
  styles: {
    global: {
      werzLogoColor: "#ffffff",
      counterColor: "#ffffff",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[174px] h-[94px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[174px] h-[94px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['HelveticaNeueRegular']",
      primaryButton:
        "bg-[#ffffff] border-2 border-[#ffffff] rounded-[6px] px-[18px] py-[18px] !text-[#222222] font-['QUIRKYSPRINGRegular'] !text-[16px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "",
      separator: "#222222",
      item: "font-['QUIRKYSPRINGRegular'] text-[16px] text-[#ffffff] text-opacity-50 text-center border-b border-[#222222] !pl-0 !py-3 gap-x-[10px]",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] !pb-8 !border !border-[#000000] !rounded-[24px]",
      titles: "text-[#ffffff] font-['QUIRKYSPRINGRegular'] text-[26px] text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#8d8d8d] font-['HelveticaNeueRegular'] text-[14px] text-left",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 border-b border-[#222222]",
        sectionTitle:
          "text-[#ffffff] font-['QUIRKYSPRINGRegular'] text-[26px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative ",
          media: "w-full !aspect-square object-cover !rounded-[24px]",
          placeholderMedia: "w-full !aspect-square bg-gray-400 !rounded-[24px]",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#ffffff] font-['QUIRKYSPRINGRegular'] text-[26px] text-left leading-[110%]",
          subtitle: "text-[#8d8d8d] font-['HelveticaNeueRegular'] text-[14px] text-left mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 border-b border-[#222222]",
        sectionTitle:
          "text-[#ffffff] font-['QUIRKYSPRINGRegular'] text-[26px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover !rounded-[18px]",
          placeholderMedia: "w-full !aspect-video bg-gray-400 !rounded-[18px]",
          content: "flex flex-col p-4 bg-transparent",
          title: "text-[#ffffff] font-['HelveticaNeueMedium'] text-[16px] text-left",
          subtitle: "text-[#8d8d8d] font-['HelveticaNeueRegular'] text-[12px] text-left mt-2",
          location: "text-[#8d8d8d] font-['HelveticaNeueRegular'] text-[12px] text-left mt-2",
          date: "text-[#8d8d8d] font-['HelveticaNeueRegular'] text-[12px] text-left mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#ffffff] font-['QUIRKYSPRINGRegular'] text-[24px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] text-left",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ffffff] font-['QUIRKYSPRINGRegular'] text-[26px] text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] !pb-8 !border !border-[#000000] !rounded-[24px]",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#222222]",
        media: "aspect-video !h-[180px] object-cover sm:mb-4 rounded-[18px]",
        title: "text-[#ffffff] font-['QUIRKYSPRINGRegular'] text-[26px] text-left leading-[110%]",
        subtitle: "text-[#8d8d8d] font-['HelveticaNeueRegular'] text-[14px] text-left mb-4",
        button:
          "bg-[#ffffff] border-2 border-[#ffffff] rounded-[6px] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#222222] font-['QUIRKYSPRINGRegular'] !text-[16px] text-left leading-[100%]",
        questions: "text-[14px] text-left text-[#8d8d8d]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#222222]",
        header: "text-[#ffffff] font-['QUIRKYSPRINGRegular'] text-[24px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#222222]",
        header: "text-[#ffffff] font-['QUIRKYSPRINGRegular'] text-[24px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#000000] rounded-[16px] gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#ffffff] font-['QUIRKYSPRINGRegular'] text-[24px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['QUIRKYSPRINGRegular'] text-[26px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#000000] border-2 border-[#ffffff] rounded-[6px] px-[16px] py-[12px] text-[#ffffff] font-['QUIRKYSPRINGRegular'] text-[14px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto !bg-[#000000] border-b border-[#000000] py-4 mb-4 border-b border-[#222222]",
          media: "!hidden",
          name: "text-[#ffffff] font-['HelveticaNeueMedium'] text-[16px] text-left",
          description:
            "text-[#8d8d8d] font-['HelveticaNeueRegular'] text-[14px] text-left flex flex-row gap-1",
          price: "text-[#8d8d8d] font-['HelveticaNeueMedium'] text-[16px] text-left",
          quantity:
            "text-[#ffffff] font-['QUIRKYSPRINGRegular'] text-[14px] text-left leading-[100%]",
          status: "text-[#8d8d8d] font-['HelveticaNeueMedium'] text-[16px] text-left",
          counterContainer:
            "bg-[#000000] border-2 border-[#ffffff] rounded-[6px] px-[16px] py-[12px] gap-x-[16px] !w-fit",
          button:
            "bg-[#000000] border-2 border-[#ffffff] rounded-[6px] px-[16px] py-[12px] text-[#ffffff] font-['QUIRKYSPRINGRegular'] text-[14px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default muumimaa
